import { round } from '../units_helpers';
import type { SelectOptionPropsType } from '@Shelly/shelly-design-system/index';

export type PrecipitationUnit = 'mm' | 'in';

const OPTIONS: PrecipitationUnit[] = ['mm', 'in'];

const MM_PER_INCH = 25.4;

export const convertPrecipitationFromMm = (valueMm: number, unit: PrecipitationUnit): number => {
	if (!Number.isFinite(valueMm)) return NaN;
	return unit === 'in' ? valueMm / MM_PER_INCH : valueMm;
};

export const precipitationUnitLabel = (unit: PrecipitationUnit): string => {
	return unit === 'in' ? 'in' : 'mm';
};

export const getPrecipitationUnitOptions = (): SelectOptionPropsType[] => {
	return OPTIONS.map((u) => ({ title: precipitationUnitLabel(u), value: u }));
};

export const convertPrecipitation = (value: number, unit: PrecipitationUnit): string => {
	if (!Number.isFinite(value)) return '--';
	const precipitation = convertPrecipitationFromMm(value, unit);
	return `${round(precipitation)} ${precipitationUnitLabel(unit)}`;
};
